export default __webpack_public_path__ + "static/media/usuarios_roles_y_permisos.5ff2257b.svg";